function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75zm-6-20C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4 19.25h-3.8c-1.92 0-2.85-.93-2.85-2.85v-1.8c0-1.92.93-2.85 2.85-2.85h3.8c1.92 0 2.85.93 2.85 2.85v1.8c0 1.92-.93 2.85-2.85 2.85zm-3.8-6c-1.08 0-1.35.27-1.35 1.35v1.8c0 1.08.27 1.35 1.35 1.35h3.8c1.08 0 1.35-.27 1.35-1.35v-1.8c0-1.08-.27-1.35-1.35-1.35h-3.8z"
})));